/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Automovenoshowenabled4Inputs */

const en__field_automovenoshowenabled4 = /** @type {(inputs: _Field_Automovenoshowenabled4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`move participants in status "bindingly registered" automatically to status "No-Show", if they have not been marked as participated for 7 days after the event ended`)
};

const de__field_automovenoshowenabled4 = /** @type {(inputs: _Field_Automovenoshowenabled4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`verschiebe Teilnehmer im Status "verbindlich angemeldet" automatisch in den Status "Nicht erschienen", wenn sie 7 Tage nach Ende der Veranstaltung noch nicht als teilgenommen markiert sind`)
};

/**
* | output |
* | --- |
* | "move participants in status \"bindingly registered\" automatically to status \"No-Show\", if they have not been marked as participated for 7 days after the event..." |
*
* @param {_Field_Automovenoshowenabled4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_automovenoshowenabled4 = /** @type {((inputs?: _Field_Automovenoshowenabled4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Automovenoshowenabled4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_automovenoshowenabled4(inputs)
	return de__field_automovenoshowenabled4(inputs)
});
export { _field_automovenoshowenabled4 as "_field_autoMoveNoShowEnabled" }